export default __webpack_public_path__ + "static/media/RegexTutorial.cb54f737.jpg";